import wrapSecureClientInterface from 'lib/secure-client';
import generalInterface from './interface';
import clientGoalInterface from './client-goal-interface';

function createApi(apis) {
  return window.API ? window.API.wrap(apis, 'xhrMutualFund') : wrapSecureClientInterface(apis, 'xhrMutualFund');
}

const generalApi = createApi(generalInterface);
const clientGoal = createApi(clientGoalInterface);

export default {
  ...generalApi,
  clientGoal,
};
